<template>
    <div class="login-body">
        <!--登录注册顶部-->
        <backindex></backindex>
        <div class="login-title">{{$t("changePwd")}}</div>
        <div class="login-area">
            <div class="login-pass">
                <div class="pass-font">{{$t("oldPwd")}}</div>
                <div class="login-input">
                    <input type="password" v-model="oldpwd" :placeholder="tips1">
                </div>
            </div>
            <div class="login-pass">
                <div class="pass-font">{{$t("newPwd")}}</div>
                <div class="login-input">
                    <input type="password" v-model="newpwd" :placeholder="tips2">
                </div>
            </div>
            <div class="login-pass">
                <div class="pass-font">{{$t("confirmPwd")}}</div>
                <div class="login-input">
                    <input type="password" v-model="newpwd2" :placeholder="tips3">
                </div>
            </div>
        </div>
        <!--按钮区域-->
        <div class="btn-area">
            <div class="login-btn" @click="changepwd">{{$t("changePwd")}}</div>
        </div>
        <!--底部组件-->
        <div class="login-bottom">
            <pagebottom></pagebottom>
        </div>
    </div>
</template>

<script>
import backindex from "@/components/common/backindex";
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "login",
  components: {
    pagebottom,
    backindex
  },
  data() {
    return {
      oldpwd: "",
      newpwd: "",
      newpwd2: "",
      tips1: "请输入旧密码",
      tips2: "请输入新密码",
      tips3: "请再次输入新密码",
    };
  },
  mounted:function(){
    this.tips1 = this.$t("inputOldPwd");
    this.tips2 = this.$t("inputNewPwd");
    this.tips3 = this.$t("inputPwd2");
  },
  methods: {
    //登录
    changepwd() {
      if(this.newpwd!=this.newpwd2){
        this.$toast({
            message: this.$t("pwdNotMatch"),
            duration: 3000
          });
        return;
      }
      this.req.resetPassword(this.oldpwd, this.newpwd).then(res => {
        if (res&&res.status == 1) {
          this.$toast({
            message: this.$t("changePwdSuccess"),
            duration: 3000
          });
          setTimeout(() => {
            this.go.goPersonal();
          }, 1000);
        }
      });
    }
  }
};
</script>

<style scoped>
.login-body {
  width: 100%;
  height: 100%;
}
.login-bottom {
  width: 100%;
  height: auto;
  margin-top: 2em;
  bottom: 0;
  left: 0;
}
.login-title {
  width: 100%;
  height: 1.33rem;
  background: #ffffff;
  border-bottom: 0.02rem solid #e6e6e6;
  font-size: 0.34rem;
  color: #ff1f4f;
  text-align: center;
  line-height: 1.33rem;
  font-weight: 700;
}
.login-area {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding-left: 0.4rem;
  padding-bottom: 1rem;
}
.login-name,
.login-pass {
  width: 100%;
  padding: 0.5rem 0 0 0;
  display: flex;
  justify-content: space-between;
}
.name-font,
.pass-font {
  font-size: 0.3rem;
  font-weight: 700;
}
.login-input {
  width: 5.25rem;
  border-bottom: 0.02rem solid #e6e6e6;
  padding: 0.06rem 0 0.5rem;
}
.login-input input {
  font-size: 0.26rem;
  line-height: 0.32rem;
  border: none;
  outline: none;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding-left: 0.2rem;
}
input::placeholder {
  color: #666666;
}
/*按钮区域*/
.btn-area {
  width: 100%;
  height: auto;
}
.login-btn,
.reg-btn {
  width: 5.8rem;
  height: 0.84rem;
  box-sizing: border-box;
  margin: 0 auto;
  font-size: 0.3rem;
  line-height: 0.84rem;
  text-align: center;
  border-radius: 0.08rem;
}
.login-btn {
  background: #ff1f4f;
  color: #ffffff;
}
.reg-btn {
  border: 0.02rem solid #ff1f4f;
  color: #ff1f4f;
}
.btn-or {
  width: 100%;
  padding: 0.4rem 0;
  text-align: center;
  font-size: 0.2rem;
  line-height: 0.2rem;
  color: #999999;
}
.btn-or span {
  padding: 0 0.26rem;
  font-weight: 700;
}
.or-line {
  display: inline-block;
  vertical-align: middle;
  width: 0.32rem;
  height: 0.02rem;
  background: #999999;
}
</style>


// WEBPACK FOOTER //
// src/components/changepwd.vue